<div class="bg-[#212326] py-[63px] relative">
    <div class="container mx-auto">
        <div
            class="grid grid-cols-12 max-sm:gap-x-[4px] max-lg:gap-x-[74px] max-lg:gap-y-10"
        >
            <div class="col-span-3 flex justify-center max-lg:col-span-12">
                <a [routerLink]="''" [rel]="'dofollow'">
                    <img
                        src="assets/images/global/logo_footer.png"
                        alt="logo Pion Vietnam"
                        title="logo Pion Vietnam"
                    />
                </a>
            </div>
            <div
                class="col-span-6 border-l border-white/40 border-solid pl-9 py-2 max-lg:col-col-span-8 max-md:col-span-12"
            >
                <nav class="ml-4">
                    <ul
                        class="flex gap-x-20 w-full list-disc max-lg:gap-x-10 max-lg:flex-wrap"
                    >
                        @for (item of menus; track $index) {
                        <li
                            class="text-white text-sizeDefault font-medium duration-300 ease-in-out hover:text-colorActive"
                            [routerLinkActive]="['is-active']"
                            [routerLinkActiveOptions]="{
                                exact: true
                            }"
                        >
                            @if(item.redirect) {
                            <a
                                class="block w-full h-full"
                                [href]="item.link"
                                target="_blank"
                                [rel]="'nofollow'"
                            >
                                {{ item.title }}
                            </a>
                            } @else {
                            <a
                                class="block w-full h-full"
                                [routerLink]="item.link"
                            >
                                {{ item.title }}
                            </a>
                            }
                        </li>
                        }
                    </ul>
                </nav>
                <div class="mt-6 max-md:mt-4">
                    <ul class="flex flex-col gap-y-6 max-md:gap-y-4">
                        <div class="flex gap-x-6 max-md:gap-x-4">
                            @for (item of contactsInfo; track $index; let index
                            = $index) { @if(index < 2) {
                            <li class="flex items-center gap-x-[10px]">
                                <img
                                    [src]="item.icon"
                                    width="24"
                                    height="24"
                                    alt=""
                                />
                                @if(index == 1) {
                                <p
                                    class="text-white text-sizeDefault font-medium"
                                >
                                    Tax: {{ item.title }}
                                </p>
                                } @else {
                                <a
                                    [href]="item.link"
                                    class="text-white text-sizeDefault font-medium"
                                    >{{ item.title }}</a
                                >
                                }
                            </li>
                            } }
                        </div>
                        <div class="flex">
                            @for (item of contactsInfo; track $index; let index
                            = $index) { @if(index == 2) {
                            <li class="flex items-center gap-x-[10px]">
                                <img
                                    [src]="item.icon"
                                    width="24"
                                    height="24"
                                    alt=""
                                />
                                <a
                                    [href]="item.link"
                                    class="text-white text-sizeDefault font-medium"
                                    >{{ item.title }}</a
                                >
                            </li>
                            } }
                        </div>
                    </ul>
                </div>
            </div>
            <div
                class="col-span-3 border-l border-white/40 border-solid pl-8 py-2 max-lg:col-span-4 max-md:col-span-12"
            >
                <div
                    class="flex items-start justify-center flex-col gap-y-8 h-full"
                >
                    <a
                        href="https://www.facebook.com/profile.php?id=100089142523230"
                        target="_blank"
                        rel="nofollow"
                    >
                        <img
                            src="assets/images/pages/footer/facebook_full.svg"
                            alt="Facebook"
                            width="100%"
                            height="40"
                        />
                    </a>
                    <a
                        href="https://www.tiktok.com/@piontech_dilamvuive"
                        target="_blank"
                        rel="nofollow"
                    >
                        <img
                            src="assets/images/pages/footer/tiktok_full.svg"
                            alt="Tiktok"
                            width="100%"
                            height="40"
                        />
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>
